import { app } from '../../../../app';

app.component('companyApplicationsList', {
    bindings: {applications: '<'},
    templateUrl: require('./added-applications-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/added-applications-list/added-applications-list.component.js